class ScrollTimeline extends HTMLElement {
  connectedCallback() {
    this.progressEl = this.querySelector('[data-timeline-progress]');
    this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));
    this.ticking = false;

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    if (!this.progressEl) return;
    const rect = this.getBoundingClientRect();
    const trigger = window.innerHeight * 0.75;
    const progress = Math.max(0, Math.min(1, (trigger - rect.top) / rect.height));

    this.progressEl.style.height = progress * 100 + '%';

    this.items.forEach((item) => {
      const itemRect = item.getBoundingClientRect();
      const itemCenter = itemRect.top + itemRect.height / 2;
      item.classList.toggle('is-active', itemCenter <= trigger);
    });
  }
}

if (!customElements.get('scroll-timeline')) {
  customElements.define('scroll-timeline', ScrollTimeline);
}
